import { useCallback, useMemo } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

export function useDetailNavigation({ cardId, cardsOfSameWorkflowStepId = [] }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: boardKey } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const currentCardIndex = useMemo(
    () =>
      cardsOfSameWorkflowStepId.findIndex(
        (item) => item.card.card_id == cardId
      ),
    [cardId, cardsOfSameWorkflowStepId]
  );

  const updateSearchParams = useCallback(
    (value) => {
      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.set("card_id", value);
      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams]
  );

  const navigateToCard = useCallback(
    (nextCardId) => {
      if (location.pathname.includes("/board/") && boardKey) {
        navigate(`/board/${boardKey}/${boardKey}-${nextCardId}`);
        return;
      }

      updateSearchParams(nextCardId);
    },
    [boardKey, location.pathname, navigate, updateSearchParams]
  );

  const handlePrevious = useCallback(() => {
    if (currentCardIndex <= 0) {
      return;
    }

    navigateToCard(cardsOfSameWorkflowStepId[currentCardIndex - 1]?.card.card_id);
  }, [cardsOfSameWorkflowStepId, currentCardIndex, navigateToCard]);

  const handleNext = useCallback(() => {
    if (
      currentCardIndex === -1 ||
      currentCardIndex >= cardsOfSameWorkflowStepId.length - 1
    ) {
      return;
    }

    navigateToCard(cardsOfSameWorkflowStepId[currentCardIndex + 1]?.card.card_id);
  }, [cardsOfSameWorkflowStepId, currentCardIndex, navigateToCard]);

  return {
    currentCardIndex,
    handleNext,
    handlePrevious,
  };
}
